import { nominalTypeHack } from 'prop-types';
import {
    drawerWidth,
    transition,
    boxShadow,
    // defaultFont,
    primaryColor,
    primaryBoxShadow,
    infoColor,
    warningColor,
    dangerColor,
    whiteColor,
    grayColor,
    blackColor,
    visitorColor,
    visitorLinkColor,
    exhibitorColor,
    hexToRgb,
    successLightColor,
    navyColor,
    hexToRgbBlur,
} from '../global';

const sidebarStyle = (theme) => ({
    drawerPaper: {
        border: 'none',
        position: 'fixed',
        top: '0',
        bottom: '0',
        left: '0',
        zIndex: '1',
        boxShadow: (props) => (props?.customColorSidebar?.sidebar?.background_color
            && `0 10px 30px -12px rgba(${hexToRgbBlur(props?.customColorSidebar?.sidebar?.background_color, 0.42)}),
            0 4px 25px 0px rgba(${hexToRgbBlur(props?.customColorSidebar?.sidebar?.background_color, 0.12)}),
            0 8px 10px -5px rgba(${hexToRgbBlur(props?.customColorSidebar?.sidebar?.background_color, 0.2)})`)
            || '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
        width: drawerWidth,
        [theme.breakpoints.up('md')]: {
            width: drawerWidth,
            position: 'relative',
            height: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: drawerWidth,
            boxShadow: (props) => (props?.customColorSidebar?.sidebar?.background_color
                && `0 10px 30px -12px rgba(${hexToRgbBlur(props?.customColorSidebar?.sidebar?.background_color, 0.42)}),
                0 4px 25px 0px rgba(${hexToRgbBlur(props?.customColorSidebar?.sidebar?.background_color, 0.12)}),
                0 8px 10px -5px rgba(${hexToRgbBlur(props?.customColorSidebar?.sidebar?.background_color, 0.2)})`)
                || '0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
            position: 'fixed',
            display: 'block',
            top: '0',
            height: '100vh',
            right: '0',
            left: 'auto',
            zIndex: '1032',
            visibility: 'visible',
            overflowY: 'visible',
            borderTop: 'none',
            textAlign: 'left',
            paddingRight: '0px',
            paddingLeft: '0',
            transform: `translate3d(${drawerWidth}px, 0, 0)`,
            ...transition,
        },
    },
    drawerPaperRTL: {
        [theme.breakpoints.up('md')]: {
            left: 'auto !important',
            right: '0 !important',
        },
        [theme.breakpoints.down('sm')]: {
            left: '0  !important',
            right: 'auto !important',
        },
    },
    logo: {
        position: 'relative',
        padding: '15px 15px',
        zIndex: '4',
        '&:after': {
            content: '""',
            position: 'absolute',
            bottom: '0',
            height: '1px',
            right: '15px',
            width: 'calc(100% - 30px)',
            backgroundColor: `rgba(${hexToRgb(grayColor)}, 0.3)`,
        },
    },
    logoLink: {
        // ...defaultFont,
        textTransform: 'uppercase',
        padding: '5px 0',
        display: 'block',
        fontSize: '18px',
        textAlign: 'left',
        fontWeight: '400',
        lineHeight: '30px',
        textDecoration: 'none',
        backgroundColor: 'transparent',
        '&,&:hover': {
            color: whiteColor,
        },
    },
    logoLinkRTL: {
        textAlign: 'right',
    },
    logoImage: {
        width: '30px',
        display: 'inline-block',
        maxHeight: '30px',
        marginLeft: '10px',
        marginRight: '15px',
    },
    img: {
        width: '35px',
        top: '22px',
        position: 'absolute',
        verticalAlign: 'middle',
        border: '0',
    },
    background: {
        position: 'absolute',
        zIndex: '1',
        height: '100%',
        width: '100%',
        display: 'block',
        top: '0',
        left: '0',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        '&:after': {
            position: 'absolute',
            zIndex: '3',
            width: '100%',
            height: '100%',
            content: '""',
            display: 'block',
            background: exhibitorColor,
            opacity: '.8',
        },
    },
    visitorBackGround: {
        position: 'absolute',
        zIndex: '1',
        height: '100%',
        width: '100%',
        display: 'block',
        top: '0',
        left: '0',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        '&:after': {
            position: 'absolute',
            zIndex: '3',
            width: '100%',
            height: '100%',
            content: '""',
            display: 'block',
            background: (props) => props?.customColorSidebar?.sidebar?.background_color || visitorColor,
            opacity: '.8',
        },
    },
    list: {
        marginTop: '20px',
        paddingLeft: '0',
        paddingTop: '0',
        paddingBottom: '0',
        marginBottom: '0',
        listStyle: 'none',
        position: 'unset',
    },
    item: {
        position: 'relative',
        display: 'block',
        textDecoration: 'none',
        '&:hover,&:focus,&:visited,&': {
            color: whiteColor,
        },
    },
    itemLink: {
        width: 'auto',
        transition: 'all 300ms linear',
        margin: '10px 15px 0',
        borderRadius: '3px',
        position: 'relative',
        display: 'block',
        padding: '10px 15px',
        backgroundColor: 'transparent',
        // ...defaultFont,
        '& svg': {
            width: '24px',
            height: '30px',
            fontSize: '24px',
            lineHeight: '30px',
            float: 'left',
            marginRight: '15px',
            textAlign: 'center',
            verticalAlign: 'middle',
            color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
        },
    },
    itemIcon: {
        width: '24px',
        height: '30px',
        fontSize: '24px',
        lineHeight: '30px',
        float: 'left',
        marginRight: '15px',
        textAlign: 'center',
        verticalAlign: 'middle',
        color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
    },
    itemIconRTL: {
        marginRight: '3px',
        marginLeft: '15px',
        float: 'right',
    },
    itemText: {
        // ...defaultFont,
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        color: whiteColor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    visitorText: {
        // ...defaultFont,
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        color: (props) => props?.customColorSidebar?.contents_text_color || blackColor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    visitorTextOther: {
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        padding: '3px 0',
        color: (props) => props?.customColorSidebar?.contents_text_color || blackColor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    visitorTextLogout: {
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        color: (props) => props?.customColorSidebar?.sidebar?.logout_text_color || blackColor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    itemTextRTL: {
        textAlign: 'right',
    },
    whiteFont: {
        color: (props) => props?.customColorSidebar?.sidebar?.selected_text_color || whiteColor,
    },
    visitorFont: {
        color: visitorLinkColor,
    },
    purple: {
        backgroundColor: primaryColor,
        ...primaryBoxShadow,
        '&:hover,&:focus': {
            backgroundColor: primaryColor,
            ...primaryBoxShadow,
        },
    },
    blue: {
        backgroundColor: infoColor,
        boxShadow:
        `0 12px 20px -10px rgba(${
            hexToRgb(infoColor)
        },.28), 0 4px 20px 0 rgba(${
            hexToRgb(blackColor)
        },.12), 0 7px 8px -5px rgba(${
            hexToRgb(infoColor)
        },.2)`,
        '&:hover,&:focus': {
            backgroundColor: infoColor,
            boxShadow:
          `0 12px 20px -10px rgba(${
              hexToRgb(infoColor)
          },.28), 0 4px 20px 0 rgba(${
              hexToRgb(blackColor)
          },.12), 0 7px 8px -5px rgba(${
              hexToRgb(infoColor)
          },.2)`,
        },
    },
    green: {
        backgroundColor: successLightColor,
        boxShadow:
        `0 12px 20px -10px rgba(${
            hexToRgb(successLightColor)
        },.28), 0 4px 20px 0 rgba(${
            hexToRgb(blackColor)
        },.12), 0 7px 8px -5px rgba(${
            hexToRgb(successLightColor)
        },.2)`,
        '&:hover,&:focus': {
            backgroundColor: successLightColor,
            boxShadow:
          `0 12px 20px -10px rgba(${
              hexToRgb(successLightColor)
          },.28), 0 4px 20px 0 rgba(${
              hexToRgb(blackColor)
          },.12), 0 7px 8px -5px rgba(${
              hexToRgb(successLightColor)
          },.2)`,
        },
    },
    orange: {
        backgroundColor: (props) => props?.customColorSidebar?.sidebar?.logout_background_color || warningColor,
        boxShadow: (props) => (props?.customColorSidebar?.sidebar?.logout_background_color
            ? `0 12px 20px -10px rgba(${
                hexToRgb(props?.customColorSidebar?.sidebar?.logout_background_color)
            },.28), 0 4px 20px 0 rgba(${
                hexToRgb(blackColor)
            },.12), 0 7px 8px -5px rgba(${
                hexToRgb(props?.customColorSidebar?.sidebar?.logout_background_color)
            },.2)`
            : `0 12px 20px -10px rgba(${
                hexToRgb(warningColor)
            },.28), 0 4px 20px 0 rgba(${
                hexToRgb(blackColor)
            },.12), 0 7px 8px -5px rgba(${
                hexToRgb(warningColor)
            },.2)`),
        '&:hover,&:focus': {
            backgroundColor: (props) => props?.customColorSidebar?.sidebar?.logout_background_color || warningColor,
            boxShadow: (props) => (props?.customColorSidebar?.sidebar?.logout_background_color
                ? `0 12px 20px -10px rgba(${
                    hexToRgb(props?.customColorSidebar?.sidebar?.logout_background_color)
                },.28), 0 4px 20px 0 rgba(${
                    hexToRgb(blackColor)
                },.12), 0 7px 8px -5px rgba(${
                    hexToRgb(props?.customColorSidebar?.sidebar?.logout_background_color)
                },.2)`
                : `0 12px 20px -10px rgba(${
                    hexToRgb(warningColor)
                },.28), 0 4px 20px 0 rgba(${
                    hexToRgb(blackColor)
                },.12), 0 7px 8px -5px rgba(${
                    hexToRgb(warningColor)
                },.2)`),
        },
    },
    red: {
        backgroundColor: dangerColor,
        boxShadow:
        `0 12px 20px -10px rgba(${
            hexToRgb(dangerColor)
        },.28), 0 4px 20px 0 rgba(${
            hexToRgb(blackColor)
        },.12), 0 7px 8px -5px rgba(${
            hexToRgb(dangerColor)
        },.2)`,
        '&:hover,&:focus': {
            backgroundColor: dangerColor,
            boxShadow:
          `0 12px 20px -10px rgba(${
              hexToRgb(dangerColor)
          },.28), 0 4px 20px 0 rgba(${
              hexToRgb(blackColor)
          },.12), 0 7px 8px -5px rgba(${
              hexToRgb(dangerColor)
          },.2)`,
        },
    },
    navy: {
        backgroundColor: (props) => props?.customColorSidebar?.sidebar?.selected_background_color || navyColor,
        boxShadow: (props) => (props?.customColorSidebar?.sidebar?.selected_background_color
            ? `0 12px 20px -10px rgba(${
                hexToRgb(props?.customColorSidebar?.sidebar?.selected_background_color)
            },.28), 0 4px 20px 0 rgba(${
                hexToRgb(blackColor)
            },.12), 0 7px 8px -5px rgba(${
                hexToRgb(props?.customColorSidebar?.sidebar?.selected_background_color)
            },.2)`
            : `0 12px 20px -10px rgba(${
                hexToRgb(navyColor)
            },.28), 0 4px 20px 0 rgba(${
                hexToRgb(blackColor)
            },.12), 0 7px 8px -5px rgba(${
                hexToRgb(navyColor)
            },.2)`),
        '&:hover,&:focus': {
            backgroundColor: (props) => props?.customColorSidebar?.sidebar?.selected_background_color || navyColor,
            boxShadow: (props) => (props?.customColorSidebar?.sidebar?.selected_background_color
                ? `0 12px 20px -10px rgba(${
                    hexToRgb(props?.customColorSidebar?.sidebar?.selected_background_color)
                },.28), 0 4px 20px 0 rgba(${
                    hexToRgb(blackColor)
                },.12), 0 7px 8px -5px rgba(${
                    hexToRgb(props?.customColorSidebar?.sidebar?.selected_background_color)
                },.2)`
                : `0 12px 20px -10px rgba(${
                    hexToRgb(navyColor)
                },.28), 0 4px 20px 0 rgba(${
                    hexToRgb(blackColor)
                },.12), 0 7px 8px -5px rgba(${
                    hexToRgb(navyColor)
                },.2)`),
        },
    },
    sidebarWrapperOrganizer: {
        backgroundColor: exhibitorColor,
    },
    sidebarWrapper: {
        position: 'relative',
        height: 'calc(100vh - 195px)',
        overflow: 'auto',
        width: '260px',
        zIndex: '4',
        overflowScrolling: 'touch',
        overflowY: 'auto',
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#0ae',
            backgroundImage: '-webkit-gradient(linear, 0 0, 0 100%, color-stop(.5, rgba(255, 255, 255, .2)),color-stop(.5, transparent), to(transparent))',
        },
    },
    logOutButton: {
        [theme.breakpoints.up('md')]: {
            bottom: '13px',
        },
    },
    brand: {
        cursor: 'pointer',
    },
    homeButton: {
        textDecoration: 'none',
        '&:hover,&:focus': {
            textDecoration: 'none',
        },
        [theme.breakpoints.up('md')]: {
            position: 'fixed',
            width: '260px',
            bottom: '70px',
        },
    },
    userbrand: {
        cursor: 'pointer',
        fontSize: '45px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
        },
    },
    userleft: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            justifyContent: 'space-between',
        },
    },
    brandMobile: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            height: '60px',
        },
    },
    docked: {
        [theme.breakpoints.up('md')]: {
            height: '100%',
            width: '260px',
        },
    },
    fixedSidebar: {
        position: 'fixed !important',
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '200px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '150px !important',
            margin: '10px  !important',
        },
    },
    countNumber: {
        marginLeft: '10px',
        display: 'block',
        padding: '0 10px',
        background: 'red',
        borderRadius: '50%',
        color: 'white',
        fontWeight: 'bold',
        height: '30px',
    },
    countPlus: {
        marginLeft: '10px',
        display: 'block',
        padding: '0 8px 2px 8px',
        background: 'red',
        borderRadius: '50%',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '23px',
        height: '32px',
    },

    // css custom layout
    sidebarCustomLayout: {
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'space-between',
            margin: 'auto',
            maxWidth: '1200px',
            width: 'calc(100% - 280px)',
            '&>footer': {
                width: '100%',
            },
        },
    },
    sideCustomLayoutLeft: {
        display: 'flex',
        width: '100%',
        position: 'relative',
    },
    sideCustomLayoutLeftWithLogin: {
        display: 'flex',
        width: 'calc(100% - 300px)',
        position: 'relative',
    },
    root: {
        marginLeft: '30px',
        '& > div > .MuiTabs-indicator': {
            display: 'none',
        },
    },
    itemLinkCustomLayout: {
        transition: 'all 300ms linear',
        position: 'relative',
        display: 'block',
        padding: '10px 15px',
        backgroundColor: 'transparent',
        '& svg': {
            width: '24px',
            height: '30px',
            fontSize: '24px',
            lineHeight: '30px',
            float: 'left',
            marginRight: '15px',
            textAlign: 'center',
            verticalAlign: 'middle',
            color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
        },
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    itemLinkCustomLayoutSurvey: {
        transition: 'all 300ms linear',
        position: 'relative',
        display: 'block',
        padding: '10px 15px',
        backgroundColor: 'transparent',
        width: '100%',
        cursor: 'pointer',
        '& svg': {
            width: '24px',
            height: '30px',
            fontSize: '24px',
            lineHeight: '30px',
            float: 'left',
            marginRight: '15px',
            textAlign: 'center',
            verticalAlign: 'middle',
            color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
        },
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    itemLinkCustomLayoutMobile: {
        transition: 'all 300ms linear',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        padding: '10px 15px',
        backgroundColor: 'transparent',
        borderBottom: '1px solid',
        '& > .MuiListItemText-root': {
            flex: 'none',
            width: '250px',
        },
        '& svg': {
            width: '24px',
            height: '30px',
            fontSize: '24px',
            lineHeight: '30px',
            float: 'left',
            marginRight: '15px',
            textAlign: 'center',
            verticalAlign: 'middle',
            color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
        },
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    nextMobile: {
        '& > .MuiListItemText-root': {
            flex: 'none',
            width: '210px',
        },
    },
    itemLinkHomeCustomLayout: {
        transition: 'all 300ms linear',
        position: 'relative',
        display: 'block',
        backgroundColor: 'transparent',
        padding: '13px 12px',
        '& svg': {
            fontSize: '24px',
            lineHeight: '30px',
            float: 'left',
            textAlign: 'center',
            verticalAlign: 'middle',
            color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
        },
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    visitorTextLogoutLayoutCustom: {
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        color: (props) => props?.customColorSidebar?.sidebar?.logout_text_color || blackColor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        textAlign: 'left',
        '& > svg': {
            float: 'right',
        },
    },
    visitorTextLogoutLayoutCustomActive: {
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        color: (props) => props?.customColorSidebar?.sidebar?.selected_text_color || whiteColor,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        textAlign: 'left',
    },
    visitorTextLogoutLayoutCustomCart: {
        margin: '0',
        lineHeight: '30px',
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        textAlign: 'left',
    },
    drawerPaperCustomLayout: {
        border: 'none',
        top: '0',
        right: '0',
        left: '0',
        zIndex: 100,
        position: 'fixed',
    },
    backgroundVisitorCustom: {
        background: (props) => props?.customColorSidebar?.sidebar?.background_color || visitorColor,
        paddingLeft: '15px',
        paddingRight: '20px',
    },
    rootTabHome: {
        backgroundColor: (props) => props?.customColorSidebar?.sidebar?.background_color || visitorColor,
        minWidth: 'auto',
        margin: '6px 0px',
        opacity: '1',
        padding: 0,
    },
    rootTab: {
        padding: '0px',
        margin: '6px 0px',
        opacity: '1 !important',
        cursor: 'default',
    },
    rootTabSurvey: {
        opacity: '1 !important',
        cursor: 'default',
        width: '260px',
        padding: '0px',
        margin: '6px 0px',
        '& > span': {
            alignItems: 'baseline',
        },
    },
    itemCustomLayout: {
        position: 'relative',
        display: 'block',
        textDecoration: 'none',
        '&:hover,&:focus,&:visited,&': {
            color: whiteColor,
        },
        width: '260px',
    },
    drawerPaperMobileCustomLayout: {
        position: 'fixed',
        zIndex: 100,
        top: '55px',
        left: 0,
        right: 0,
        bottom: 0,
        '& > ul': {
            marginTop: 0,
            backgroundColor: (props) => props?.customColorSidebar?.sidebar?.background_color || visitorColor,
            maxHeight: '350px',
            overflow: 'auto',
        },
    },
    opacityMobile: {
        width: '100%',
        height: '100%',
        backgroundColor: '#333',
        opacity: 0.6,
        margin: 0,
    },
    translateOpen: {
        display: 'block',
        listStyle: 'none',
        paddingLeft: '50px',
        marginRight: '15px',
    },
    translateOpenMobile: {
        display: 'flex',
        listStyle: 'none',
        paddingLeft: '50px',
        paddingRight: '50px',
        flexDirection: 'column',
        alignItems: 'center',
        color: 'rgb(0, 0, 0)',
    },
    translateOpenCustom: {
        display: 'block',
        listStyle: 'none',
        paddingLeft: '20px',
        position: 'absolute',
        right: '58px',
        top: '34px',
        background: 'rgb(178, 209, 249);',
        width: '220px',
        zIndex: 3,
    },
    translateClose: {
        display: 'none',
    },
    itemTranslate: {
        width: 'auto',
        transition: 'all 300ms linear',
        margin: '10px 15px 0',
        borderRadius: '3px',
        position: 'relative',
        display: 'flex',
        padding: '10px 15px',
        backgroundColor: 'transparent',
        // ...defaultFont,
        '& svg': {
            width: '24px',
            height: '30px',
            fontSize: '24px',
            lineHeight: '30px',
            float: 'left',
            marginRight: '15px',
            textAlign: 'center',
            verticalAlign: 'middle',
            color: `rgba(${hexToRgb(whiteColor)}, 0.8)`,
        },
    },

    test: {
        textAlign: 'left',
        '& .goog-logo-link': {
            display: 'none !important',
        },
        '& .goog-te-gadget': {
            color: 'transparent !important',
            '& span': {
                display: 'none',
            },
        },
        '& .goog-te-combo': {
            border: 'none',
            backgroundColor: 'transparent !important',
            cursor: 'pointer',
            fontSize: '16px',
            marginLeft: '-4px !important',
            width: '150px',
        },
        '& .goog-te-combo:focus': {
            outline: 'none',
        },
        padding: '0 16px !important',
    },
    googleMobile: {
        textAlign: 'left',
        '& .goog-logo-link': {
            display: 'none !important',
        },
        '& .goog-te-gadget': {
            color: 'transparent !important',
        },
        '& .goog-te-combo': {
            border: 'none',
            backgroundColor: 'transparent !important',
            cursor: 'pointer',
            fontSize: '16px',
            marginLeft: '-4px !important',
            width: '150px',
        },
        '& .goog-te-combo:focus': {
            outline: 'none',
        },
        padding: '0 16px !important',
        width: '250px',
    },
    mainItemTranslate: {
        padding: '0 16px',
        margin: '4px 0',
    },
    mainItemTranslateMobile: {
        padding: '0 16px',
        margin: '4px 0',
        textAlign: 'left',
        width: '250px',
    },
});

export default sidebarStyle;
